/**
 * Cart Recommendation Card Component
 * Handles add-to-cart functionality for recommendation cards in the cart drawer.
 * Adds items without closing the drawer.
 */
(function() {
  if (customElements.get('cart-recommendation-card')) return;

  class CartRecommendationCard extends HTMLElement {
    constructor() {
      super();
      this.variants = [];
      this.currentVariantId = null;
    }

    connectedCallback() {
      this.variants = JSON.parse(this.dataset.variants || '[]');
      this.currentVariantId = parseInt(this.dataset.variantId, 10);
      
      const variantSelect = this.querySelector('[data-variant-select]');
      if (variantSelect) {
        variantSelect.addEventListener('change', (e) => this.handleVariantChange(e));
      }

      const addButton = this.querySelector('[data-add-button]');
      if (addButton) {
        addButton.addEventListener('click', (e) => this.handleAddToCart(e));
      }
    }

    handleVariantChange(e) {
      const select = e.target;
      const option = select.options[select.selectedIndex];
      const variantId = parseInt(option.value, 10);
      const price = option.dataset.price;
      const comparePrice = option.dataset.comparePrice;
      const available = option.dataset.available === 'true';
      const imageSrc = option.dataset.image;

      this.currentVariantId = variantId;
      this.dataset.variantId = variantId;

      const priceDisplay = this.querySelector('[data-price-display]');
      if (priceDisplay) {
        priceDisplay.textContent = price;
        priceDisplay.classList.toggle('cart-rec-card__sale-price--on-sale', !!comparePrice);
      }

      const comparePriceDisplay = this.querySelector('[data-compare-price-display]');
      if (comparePrice) {
        if (comparePriceDisplay) {
          comparePriceDisplay.textContent = comparePrice;
          comparePriceDisplay.style.display = '';
        } else {
          const pricesContainer = this.querySelector('[data-prices-container]');
          const priceEl = this.querySelector('[data-price-display]');
          if (pricesContainer && priceEl) {
            const span = document.createElement('span');
            span.className = 'cart-rec-card__compare-price';
            span.setAttribute('data-compare-price-display', '');
            span.textContent = comparePrice;
            pricesContainer.insertBefore(span, priceEl);
          }
        }
      } else if (comparePriceDisplay) {
        comparePriceDisplay.style.display = 'none';
      }

      const addButton = this.querySelector('[data-add-button]');
      if (addButton) {
        addButton.disabled = !available;
        addButton.dataset.added = 'false';
      }

      const variantImage = this.querySelector('[data-variant-image]');
      if (variantImage && imageSrc) variantImage.src = imageSrc;
    }

    async handleAddToCart(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const addButton = this.querySelector('[data-add-button]');
      if (!addButton || addButton.disabled || addButton.dataset.added === 'true') return;
      
      const cartAddUrl = this.dataset.cartAddUrl || '/cart/add.js';
      
      addButton.disabled = true;
      
      try {
        const formData = new FormData();
        formData.append('id', this.currentVariantId);
        formData.append('quantity', '1');
        
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          body: formData
        });
        
        const result = await response.json().catch(() => ({}));
        
        if (!response.ok || (result.status && result.status !== 200)) {
          throw new Error(result.description || result.message || 'Failed to add to cart');
        }
        
        addButton.dataset.added = 'true';
        addButton.disabled = false;
        
        // Fetch updated cart data
        const cartRes = await fetch('/cart.js');
        const cartData = cartRes.ok ? await cartRes.json() : {};
        
        // Dispatch the standard cart:update event to refresh the cart drawer
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartData,
            sourceId: this.dataset.productId,
            data: {
              source: 'recommendation-card',
              itemCount: cartData.item_count,
              variantId: String(this.currentVariantId)
            }
          }
        }));

        // Reset button after a short delay
        setTimeout(() => {
          addButton.dataset.added = 'false';
        }, 2000);
        
      } catch (error) {
        console.error('Cart recommendation add error:', error);
        addButton.disabled = false;
      }
    }
  }

  customElements.define('cart-recommendation-card', CartRecommendationCard);
})();
